export default __webpack_public_path__ + "static/media/floor0.eee19d11.svg";